import React from 'react';
import classes from './PageConnector.module.scss'

function PageConnector() {
   return (
      <div className={classes.PageConnector}>
      </div>
   );
}
export default PageConnector;